import type { CharacterRow } from '../../../lib/types';
import type { DraftChild } from '../lib';

interface RosterItemProps {
  child: DraftChild;
  characterById: (id: number | null) => CharacterRow | null;
  onEdit: (draftId: string) => void;
  disabled?: boolean;
}

export function RosterItem({ child, characterById, onEdit, disabled }: RosterItemProps) {
  const fighter = characterById(child.character_id);
  return (
    <li className="smash-roster-item">
      {fighter?.image_url && (
        <img
          src={fighter.image_url}
          alt={fighter.name}
          className="smash-roster-item__avatar"
        />
      )}
      <div className="smash-roster-item__body">
        <div className="smash-roster-item__name">{child.child_name}</div>
        <div className="smash-roster-item__meta">
          {child.status === 'coming'
            ? `${fighter ? fighter.name : 'No fighter'} · ${child.shirt_size ?? '—'}`
            : 'Not coming'}
        </div>
        {child.error && (
          <div className="smash-roster-item__error">{child.error}</div>
        )}
      </div>
      <button type="button" onClick={() => onEdit(child.draftId)} disabled={disabled}>
        Edit
      </button>
      {child.submitted && <span className="smash-roster-item__ok">✓</span>}
    </li>
  );
}
